<template>
  <cos-modal
    v-model:visible="visible"
    title="发券申请"
    width="670px"
    :confirm-loading="loading"
    @ok="handleBecomeInvalidOk"
  >
    <a-form :model="dataForm" ref="formRef" v-if="visible">
      <a-form-item name="cosId" label="客户名称">
        <CosSelect
          v-model:value="dataForm.cosId"
          :options="selectedData"
          :fieldNames="{ label: 'customerName', value: 'cosId' }"
          disabled
        />
      </a-form-item>
      <a-form-item
        name="actCode"
        label="营销活动"
        :span="24"
        :rules="{
          message: '请选择',
          required: true
        }"
      >
        <ParamCodesSelect
          v-model:value="dataForm.actCode"
          :options="paramCodeData.list_activity"
          :fieldNames="{ label: 'actName', value: 'actCode' }"
          allowClear
        />
      </a-form-item>
      <a-form-item
        name="reason"
        label="申请原因"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInput v-model:value="dataForm.reason" :maxlength="200" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script setup lang="ts">
import { ref, onBeforeMount } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import type { ParamCodeItem } from '@/typings/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
import CosInput from '@/components/Antd/CosInput/index.vue'
import request from '@/utils/request'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<PotentialItem[]>([])
const formRef = ref()
const dataForm = ref<any>({})

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  list_activity: []
})
// 获取业务参数
const getByParamCodes = () => {
  request.post('lbu/api/coupons/listActivity').then((res) => {
    paramCodeData.value.list_activity = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const toggle = (data: PotentialItem[]) => {
  if (data.length !== 1) return DcMessage.error('每次只能选择一个客户发起')
  const item = data[0]
  if (!item.tmsCode && !item.customerSerial) {
    return DcMessage.error('仅能选择有客户代码或客户识别码的客户')
  }
  dataForm.value = {
    cosId: item.cosId
  }
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['success'])
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const p = dataForm.value
    p.actName = paramCodeData.value.list_activity.find((item) => item.actCode === p.actCode)?.actName
    request
      .post('lbu/api/coupons/apply', dataForm.value)
      .then(() => {
        DcMessage.success('发券申请成功')
        visible.value = false
        emit('success')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
defineExpose({ toggle })
</script><script lang="ts">
export default { name: 'ApplyCoupon' }
</script>
